// @flow

export const PermissionEnum: { [string]: string } = {
  ACCESS_ADMIN: "app.access.admin",
  ACCESS_ADMIN_CLIENT: "app.access.admin.client",
  ACCESS_ADMIN_DATA: "app.access.admin.data",
  ACCESS_ADMIN_DATA_SET_DATE_RECEIVED: "app.access.admin.data.set-date-received",
  ACCESS_ADMIN_EMPLOYEE: "app.access.admin.employee",
  ACCESS_ADMIN_EMPLOYEE_MEDICAL_DETAILS: "app.access.admin.employee-medical",
  ACCESS_ADMIN_HIERARCHY: "app.access.admin.hierarchy",
  ACCESS_ADMIN_SERVICE: "app.access.admin.service-config",
  ACCESS_MANAGEMENT_CONTACT_CENTRE: "app.access.management.contact-centre",
  ACCESS_MANAGEMENT_SYSTEM: "app.access.management.system",
  ACCESS_MANAGEMENT_CLINICAL_GOVERNANCE: "app.access.management.clinical-governance",
  ACCESS_RECORDING: "app.access.recording",
  ACCESS_RECORDING_INCOMING: "app.access.recording.incoming",
  ACCESS_RECORDING_OUTBOUND: "app.access.recording.outbound",
  ACCESS_RECORDING_TRANSFER: "app.access.recording.transfer",
  ACCESS_REPORTING: "app.access.reporting",
  ACCESS_REPORTING_FOCUS_LIST: "app.access.reporting.focus-list",
  ACCESS_REPORTING_REPORTS: "app.access.reporting.reports",
  ACCESS_REPORTING_TOOLS: "app.access.reporting.tools",
  ACCESS_REPORTING_TRENDS: "app.access.reporting.trends",
  ACCESS_REPORTING_EMPLOYEES: "app.access.reporting.employees",
  ACCESS_REPORTING_MANAGERS: "app.access.reporting.managers",
  ACCESS_REPORTING_TRAINING: "app.access.reporting.training",
  ACCESS_REPORTING_REFERRALS: "app.access.reporting.referrals",
  ACCESS_REPORTING_PRESENTATIONS: "app.access.reporting.mi-report",
  APP_GLOBAL_CONTEXT_SWITCH: "app.global.context.switch",
  PRIVILEGE_EMPLOYEE_ABSENCE_CONSENT_TO_SHARE_UPDATE:
    "privilege.employee.absence.consent-to-share.update",
  PRIVELEGE_EMPLOYEE_IMPERSONATE: "privilege.employee.impersonate",
  PRIVILEGE_CLINICAL_INCIDENT: "privilege.clinical-incident",
  PRIVILEGE_CLINICAL_INCIDENT_UPDATE: "privilege.clinical-incident.update",
  PRIVILEGE_CLINICAL_INCIDENT_READ: "privilege.clinical-incident.read",
  PRIVILEGE_CLINICAL_INCIDENT_CREATE: "privilege.clinical-incident.create",
  APP_ACCESS_REPORTING_DATA_FORECASTING: "app.access.reporting.data-forecasting",
  ACCESS_MANAGEMENT_SERVICE_DESK: "app.access.service-desk",
  PRIVILEGE_HEALTH_NOTICES_WRITE: "privilege.health-notice.write",
  PRIVILEGE_HEALTH_NOTICES_DELETE: "privilege.health-notice.remove",
  PRIVILEGE_HEALTH_NOTICES_PUBLISH: "privilege.health-notice.publish",
  PRIVILEGE_HEALTH_CLASSIFICATIONS: "privilege.master.classification",
};

export default PermissionEnum;

export const ClientPermissionEnum: { [string]: string } = {
  EAP_SIGNPOSTING: "eapSignposting",
  REFERRAL_TRACKING: "referralTracking",
  ABSENCE_MONITORING: "absenceMonitoring",
  DATA_FORECASTING_ACCESS: "dataForecastingAccess",
};
